import React, { useCallback, useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { setSeoMetadata } from '../lib/seo';
import TransferSend from '../tools/transfer/TransferSend';

const TransferPage = () => {
  const { siteName } = useSiteSettings();
  const [brand, setBrand] = useState(null);
  const onConfig = useCallback((c) => setBrand(c.brand), []);

  const name = brand?.brand_name || 'Send files';
  const tagline = brand?.brand_tagline || 'Send big files, simply.';
  const description = `${tagline} Share large files with a private, expiring link.${siteName ? ` By ${siteName}.` : ''}`;

  useEffect(() => {
    setSeoMetadata({
      title: brand?.brand_name ? `${brand.brand_name} - Send Large Files` : 'Send Large Files',
      description,
      keywords: 'send large files, file transfer, share files online, secure file sharing',
      canonicalPath: '/transfer',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        name,
        description,
        applicationCategory: 'UtilitiesApplication',
        operatingSystem: 'Any',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
      },
    });
  }, [brand, description, name]);

  return (
    <div className="min-h-screen bg-[#1a1c1b] text-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-2xl mx-auto px-4">
          <header className="text-center mb-8">
            {brand?.brand_logo_url && (
              <img src={brand.brand_logo_url} alt="" className="h-12 mx-auto mb-4 object-contain" />
            )}
            <h1 className="text-3xl md:text-5xl font-bold mb-3">{name}</h1>
            <p className="text-[#888680] text-lg">{tagline}</p>
          </header>
          <TransferSend skin="dark" onConfig={onConfig} />
          <section className="mt-12 grid sm:grid-cols-3 gap-4 text-center text-sm text-[#888680]" aria-label="How it works">
            <article><h2 className="text-white font-semibold mb-1">1. Add files</h2><p>Drop in what you want to send.</p></article>
            <article><h2 className="text-white font-semibold mb-1">2. Get a link</h2><p>Optionally add a password or email it.</p></article>
            <article><h2 className="text-white font-semibold mb-1">3. It expires</h2><p>Files are deleted automatically.</p></article>
          </section>
          {brand?.footer_text && <p className="mt-8 text-center text-xs text-[#666]">{brand.footer_text}</p>}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TransferPage;
